'use strict';

module Patersons {
    export interface TwoFactorAuthenticationScope extends ng.IScope {
        twoFactorAuthForm: ng.IFormController;
        events: Patersons.TwoFactorAuthenticationCtrl;
        isError: boolean;
        isSubmitted: boolean;
        informationMessage: string;
        errorMessage: string;
        verificationCode: string;
        isSendingCode: boolean;
        isBusy: boolean;
        nameOfPdf: string;
        linkToPdf: string;
    }

    export abstract class TwoFactorAuthenticationCtrl {
        scope: Patersons.TwoFactorAuthenticationScope;
        modalInstance: any;
        identityService: IdentityService;

        static $inject = ['$scope', '$uibModalInstance', 'identityService'];

        constructor($scope, $uibModalInstance, identityService) {
            this.scope = $scope;
            this.scope.events = this;
            this.modalInstance = $uibModalInstance;
            this.identityService = identityService;

            this.scope.isError = false;
            this.scope.isSubmitted = false;
            this.scope.informationMessage = null;
            this.scope.errorMessage = null;

            this.scope.isSendingCode = false;
            this.scope.isBusy = false;

            this.sendVerificationCode();
        }

        sendVerificationCode() {
            this.scope.isSendingCode = true;
            this.scope.isSubmitted = false;
            this.scope.informationMessage = "Sending verification code...";
            this.scope.errorMessage = null;

            this.identityService.request2FAToken()
                .then((result) => {
                    this.scope.isError = false;
                    this.scope.informationMessage = "A code has been sent via SMS to the mobile number registered on this profile. Please enter this code below to verify your identity.";
                },
                (reason) => {
                    this.scope.isError = true;
                    this.scope.informationMessage = null;
                    this.scope.errorMessage = "Failed to send verification code. Please request a new code.";
                })
                .finally(() => {
                    this.scope.isSendingCode = false;
                });
        }

        submit() {
            this.scope.isSubmitted = true;
            this.modalInstance.close();
        }

        cancel() {
            this.scope.isSubmitted = false;
            this.modalInstance.dismiss();
        }

        handleErrorResponse(reason) {
            if (reason.status === 403) {
                this.showForbiddenMessage();
            }
            else {
                this.modalInstance.close(false);
            }
        }

        showForbiddenMessage() {
            this.scope.isError = true;
            this.scope.informationMessage = null;
            this.scope.errorMessage = "The code you have entered is incorrect. Please try again, or click “Resend Code”. ";
        }
    }
}